import { render, staticRenderFns } from "./TaxiZonesSummary.vue?vue&type=template&id=5179310d&scoped=true&"
import script from "./TaxiZonesSummary.vue?vue&type=script&lang=js&"
export * from "./TaxiZonesSummary.vue?vue&type=script&lang=js&"
import style0 from "./TaxiZonesSummary.vue?vue&type=style&index=0&id=5179310d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5179310d",
  null
  
)

export default component.exports